"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupAllEventBySameTournament = groupAllEventBySameTournament;
const flowFp_1 = __importDefault(require("../functions/flowFp"));
const groupByFp_1 = __importDefault(require("../functions/groupByFp"));
const mapFp_1 = __importDefault(require("../functions/mapFp"));
/**
 * !!! Function does NOT guarantee order of events
 *
 * Create event groups, grouped by tournaments
 * @param events Event[]
 * @returns EventsGroup[]
 */
function groupAllEventBySameTournament(events) {
    return (0, flowFp_1.default)((0, groupByFp_1.default)('tournament.id'), (0, mapFp_1.default)((value) => ({
        ...value[0].tournament,
        events: value,
    })))(events);
}
//# sourceMappingURL=groupAllEventsBySameTournament.js.map